// Core imports
import * as React from 'react';
import WarrantyClaimService from 'src/services/warrantyClaim/warrantyClaimService';
import DamageClaimService from 'src/services/DamageClaim/DamageClaimService';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import ReceivedUsedPartClaimInfo from 'src/components/ReceivedUsedPart/ReceivedUsedPartClaimInfo';
import ReceivedUsedPartServiceInfo from 'src/components/ReceivedUsedPart/ReceivedUsedPartServiceInfo';
import ReceivedUsedPartMoreInfo from 'src/components/ReceivedUsedPart/ReceivedUsedPartMoreInfo';
import ReceivedUsedPartPartInfo from 'src/components/ReceivedUsedPart/ReceivedUsedPartPartInfo';
import ReceivedUsedPartsubmittedPage from 'src/components/ReceivedUsedPart/ReceivedUsedPartsubmittedPage';
import './ReceivedUsedPart.scss';
import Button from '@material-ui/core/Button';
import { goToHome, goToPartClaim } from 'src/utils/navigation';
import env from 'src/shared/env';
import { HalfCircleSpinner } from 'react-epic-spinners';

import {
  UsphoneNumberRegEx,
  emailcapsRegEx,
  commentsRegEx,
  NonkeycharacterRegEx
} from 'src/utils/RegexUtils';

import i18n from 'src/translation/i18n';
import UserModel from 'src/model/user.model';
import AlertMessage from 'src/components/WarrantyClaimForm/AlertMessage';

import ClaimDetailsModel from 'src/model/ClaimDetails.model';
import ClaimPartDetails from 'src/model/ClaimPartDetails.model';

interface IDamagedProps {
  t?: any;
  userData: UserModel;
  cResubmitDetails: ClaimPartDetails;
  RSClaimDetails: ClaimDetailsModel;
  ResetDamagVW: boolean;
  backToDashBoard: () => void;
}

class ReceivedUsedPart extends React.Component<
  IDamagedProps,
  IDamageClaimFormState
> {
  public uploadQueue: any[] = [];
  public deletepic: any[] = [];
  public selectRef: any = null;
  public Minimumpicture: number =
    env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 4 : 3;
  constructor(props: any) {
    super(props);
    this.state = {
      DamageData: {
        DamageaccountNumber: this.props?.userData?.accountId
          ? this.props.userData.accountId
          : '',
        DamageclaimNumber: '',
        DamagecustomerNumber: localStorage.getItem('activeAccount'),
        Damagerefno: '',
        Damageerrormsg: '',
        Damageerrormsgshow: false,
        picspinnerspinning: false,
        Erroredpic: false,
        DamagepartDetails: [{ ...this.DamagepartBase }],
        DamageservicerEmail: '',
        DamageservicerPhone: '',
        submittedsuccessfully: false,
        Ddupimage: false,
        DamageAdditionalComment: ''
      },
      Damageerrors: {
        DamagerefnoError: false,
        DamageservicerEmailError: false,
        DamageservicerPhoneError: false,
        DamageAdditionalCommentError: false,
        DamagepartErrors: [{ ...this.DamagepartError }],
      },
      isSubmitButtonDisabled: false
    };
  }
  private DamagepartError = {
    DamagepartNumberError: false,
    DamageInvoiceNumberError: false,
    DamagequantityError: false,
    DamagequantityReceivedError: false,
    DamageUnitpriceError: false,
    DamageTotalpriceError: false,
    DescriptionOfDamageError: false
  };

  
  private DamagepartBase = {
    DpartNumber: '',
    Dquantity: 0,
    Dprice: 0,
    Dtotalprice: '',
    Dunitprice: '',
    Dunitpricenum: 0,
    DinvoiceNumber: 0,
    Dtempquantity: 1,
    DamageDescription: '',
    Dquantityshow: '',
    Dpriceshow: '',
    Dcount: 0,
    Dpicofpart: [''],
    DfileArray: [''],
    Dtempfilearray: [''],
    Duploadedfile: [''],
    Dimagepreview: [''],
    DshowUploadModal: false,
    Dtestpartnum: '',
    Dmfg: '',
    DwholePartNumber: '',
    Dfileobject: [''],
    Dpictureofparts: [
      {
        Dfilename: '',
        Dspinner: '',
        Dfile: [''],
        Dimagecount: 0,
        Dimgfail: '',
        Dimgthumbnail: ''
      }
    ],
    DpartSelectedDetails: [
      {
        invoiceNumber: 'Select Invoice',
        partNumber: '',
        availableQuantity: 0,
        unitPrice: 0,
        purchaseDate: '',
        manufacturerCode: '',
        invoiceDate: '',
        wholePartNumber: ''
      }
    ],
    DInvoiceoption: {},
    DpartInvoiceList: [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false,
        wholePartNumber: ''
      }
    ]
  };

  // Backend data //

  private Backendata = () => {
    const DamageData: any = { ...this.state.DamageData };
    const DpartDetails: any[] = [];
    DamageData.DamagepartDetails.map((value: any, i: number) => {
      DpartDetails.push({
        descriptionOfDamage: value.DamageDescription
          ? value.DamageDescription
          : '',
        invoiceNumber: value.DinvoiceNumber,
        manufacturerCode: value.Dmfg ? value.Dmfg : '',
        partLineIndex: i + 1,
        partNumber: value.DpartNumber ? value.DpartNumber.toUpperCase() : '',
        wholePartNumber: value.DwholePartNumber ? value.DwholePartNumber : '',
        pictureOfPart: value.Dcount >= this.Minimumpicture ? 'Y' : 'N',
        purchaseDate: value.DinvoicePurchaseDate ? value.DinvoicePurchaseDate : '',
        qtyUsed: Number(value.Dquantity),
        replacementDate: 0,
        replacementInvoice: '',
        totalPrice: value.Dprice,
        unitPrice: value.Dunitpricenum
      });
    });
    const DamageClaimData: any = {
      accountNumber: DamageData.DamagecustomerNumber,
      brand: '',
      claimResubmit: '',
      previousClaimNumber: '',
      claimNumber: DamageData.DamageclaimNumber,
      customer: {
        address: '',
        city: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        state: '',
        zipCode: ''
      },
      customerComplaint: '',
      locationForReturn: '',
      failedDate: 0,
      installedDate: 0,
      isReturned: '',
      modelBrand: '',
      modelNumber: '',
      part: DpartDetails,
      purchaseCost: 0,
      referenceNumber: DamageData.Damagerefno,
      repairDate: 0,
      requestReturnTag: '',
      serialNumber: '',
      servicePerformed: '',
      servicerEmail: DamageData.DamageservicerEmail,
      servicerPhoneNumber: DamageData.DamageservicerPhone
        ? DamageData.DamageservicerPhone
        : '',
      source: 'NS3DAM',
      supplierInvoiceNumber: '',
      supplierInvoiceDate: 0,
      supplierOrderNumber: '',
      supplierPoNumber: '',
      trackingNumber: '',
      incidentNumbers: '',
      productTypes: '',
      additionalComment:DamageData.DamageAdditionalComment,
      claimType:'receivedUsedPart'
    };
    // console.log(DamageClaimData,DamageData, 'DamageClaimData');
    if (this.props.RSClaimDetails) {
      DamageClaimData.claimResubmit = 'Y';
      DamageClaimData.previousClaimNumber = this.props.RSClaimDetails.claimNumber;
      const pDetails = this.props.RSClaimDetails.partNumber.split(' ');
      DamageClaimData.part[0].manufacturerCode = pDetails[0];
      DamageClaimData.part[0].wholePartNumber = this.props.RSClaimDetails.partNumber;
    }
    return DamageClaimData;
  };

  //  getting ClaimNumber  //

  public componentDidMount = () => {
    this.setState({
      isSubmitButtonDisabled: false
    });
    const sendClaimType="receivedUsedPart";
    DamageClaimService.getNewClaimNumber(sendClaimType)
      .then((claimNumber: any) => {
        // let objDamag: any = null;
        if (this.props.RSClaimDetails) {
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageclaimNumber: claimNumber.data
            }
          });
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageservicerEmail: this.props.RSClaimDetails.servicerEmail
            }
          });
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageservicerPhone: this.props.RSClaimDetails.servicerPhoneNumber
            }
          });
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              Damagerefno: this.props.RSClaimDetails.yourReferenceNumber
            }
          });

          const index: number = 0;
          const DamagepartState = {
            ...this.state.DamageData.DamagepartDetails[index]
          };
          const wholeerror = {
            ...this.state.Damageerrors.DamagepartErrors[index]
          };
          const DamagepartDetails = [
            ...this.state.DamageData.DamagepartDetails
          ];
          const Damageparterrors = [
            ...this.state.Damageerrors.DamagepartErrors
          ];

          const pDetails = this.props.RSClaimDetails.partNumber.split(' ');
          const promise1 = new Promise((resolve, reject) => {
            WarrantyClaimService.getPartnumber(
              'N',
              pDetails[pDetails.length - 1],
              true
            )
              .then(response => {
                let selectedPartDetails: any[] = [];
                const partInvoiceLst: any[] = [];
                const partInvoiceShow: any[] = [];
                selectedPartDetails = response && response['data'];
                if (selectedPartDetails && selectedPartDetails.length > 0) {
                  // console.log('selectedPartDetails', selectedPartDetails);
                  DamagepartState['DpartSelectedDetails'] = selectedPartDetails;

                  selectedPartDetails.map(a => {
                    return partInvoiceLst.push({
                      value:
                        a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
                      label:
                        a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
                      invnum: a.invoiceNumber,
                      isDisabled: a.availableQuantity <= 0 ? true : false,
                      quantity: a.availableQuantity,
                      unitPrice: a.unitPrice
                    });
                  });
                  DamagepartState['DpartInvoiceList'] = partInvoiceLst;
                }
                resolve('csInvoiceList');
              })
              .catch(error => {
                // console.log(error);
                DamagepartState['DpartSelectedDetails'] = [];
                resolve('csInvoiceList');
              });
          });
          Promise.all([promise1]).then((values: any) => {
            const cspInvoiceList: any = DamagepartState['DpartInvoiceList'];
            // console.log('Promise all', DamagepartState['DpartInvoiceList']);
            // debugger;
            const iIndex = cspInvoiceList.findIndex(
              (p: any) =>
                p.invnum === this.props.RSClaimDetails.originalInvoiceNumber
            );

            DamagepartState[
              'DinvoiceNumber'
            ] = this.props.RSClaimDetails.originalInvoiceNumber;
            DamagepartState['Dprice'] =
              this.props.RSClaimDetails.totalPrice *
              this.props.RSClaimDetails.quantity *
              1;
            DamagepartState['Dpriceshow'] = this.getAmountFixedValue(
              this.props.RSClaimDetails.totalPrice *
                this.props.RSClaimDetails.quantity *
                1
            );
            DamagepartState['Dquantity'] =
              this.props.RSClaimDetails.quantity * 1;
            DamagepartState['DInvoiceOption'] = {
              value: this.props.RSClaimDetails.originalInvoiceNumber,
              label: this.props.RSClaimDetails.originalInvoiceNumber,
              invnum: this.props.RSClaimDetails.originalInvoiceNumber,
              isDisabled: true
              // quantity: this.props.RSClaimDetails.quantity*1
            };

            DamagepartState['Dunitprice'] = this.getAmountFixedValue(
              this.props.cResubmitDetails.cspUnitPrice
            );
            DamagepartState[
              'Dunitpricenum'
            ] = this.props.cResubmitDetails.cspUnitPrice;
            // console.log('CSP Index', iIndex);
            if (iIndex > -1) {
              DamagepartState['Dtestpartnum'] = 'filled';
              DamagepartState['Dtempquantity'] = cspInvoiceList[iIndex].quantity;
            }
            DamagepartState[
              'damageDescription'
            ] = this.props.RSClaimDetails.damageDescription;
            DamagepartState.DamageDescription = this.props.RSClaimDetails.damageDescription;
            wholeerror.DamageInvoiceNumberError = false;
            wholeerror.DamagequantityError = false;
            DamagepartState.DpartNumber = pDetails[pDetails.length - 1];

            DamagepartDetails[index] = DamagepartState;
            DamagepartDetails[
              index
            ].DamageDescription = this.props.RSClaimDetails.damageDescription;
            DamagepartDetails[index][
              'damageDescription'
            ] = this.props.RSClaimDetails.damageDescription;
            this.setState({
              DamageData: {
                ...this.state.DamageData,
                DamagepartDetails
              }
            });
             // Validation - if tempquantity is 0 then  do not allow to resubmit claim
             if(DamagepartState['Dtempquantity']<=0){
              const quantityerror = [...this.state.Damageerrors.DamagepartErrors];
              const error = true;
              error
              ? (quantityerror[index].DamagequantityError = error)
              : (quantityerror[index].DamagequantityError = false);
              this.setState({
                Damageerrors: {
                  ...this.state.Damageerrors,
                  DamagepartErrors: [...quantityerror]
                }
              });
             }
          });
        } else {
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageclaimNumber: claimNumber.data
            }
          });
        }
      })
      .catch((error: any) => console.log(error));
  };

  // go to damage claim //
  private getAmountFixedValue = (amount: any) => {
    const amountVal = Number(amount);
    if (amountVal) {
      return `$${amountVal.toFixed(2)}`;
    }
    return '$0.00';
  };
  private goToDamageClaim = () => {
    WarrantyClaimService.getClaimNumber().then((claimNumber: any) => {
      this.setState({
        DamageData: {
          ...this.state.DamageData,
          DamageclaimNumber: claimNumber.data
        }
      });
    });
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        submittedsuccessfully: false
      }
    });
  };

  //  Reference Number //


  //  Servicer Email  //

  private handleDamageserviceremail = (event: any) => {
    const { name, value } = event.target;
    const error =
      !emailcapsRegEx.test(value) || value.length > 50 || value === '';
    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamageservicerEmail: value
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamageservicerEmailError: error
      }
    });
  };

  // Servicer Phone //

  private handleDamageservicerphone = (event: any) => {
    const { name, value } = event.target;
    const phonetest = value
      ? value
          .match(/\d+/g)
          .join('')
          .replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3')
      : '';
    const error = value ? !UsphoneNumberRegEx.test(phonetest) : false;

    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamageservicerPhone: phonetest
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamageservicerPhoneError: error
      }
    });
  };

  // Parts RELATED FUNCTIONS //

  // Handle part number  //

  private handleDamagePartNumber = (event: any, index: number) => {
    const { name, value } = event.target;
    const customerState = { ...this.state.DamageData };
    const DamagepartState = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    const wholeerror = { ...this.state.Damageerrors.DamagepartErrors[index] };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const Damageparterrors = [...this.state.Damageerrors.DamagepartErrors];
    DamagepartState['DpartSelectedDetails'] = [];
    DamagepartState['DinvoiceNumber'] = 0;
    DamagepartState['Dprice'] = 0;
    DamagepartState['Dpriceshow'] = '$0.00';
    DamagepartState['Dquantity'] = 0;
    DamagepartState['DInvoiceOption'] = {
      value: 'Select Invoice',
      label: 'Select Invoice',
      invnum: 'Select Invoice',
      isDisabled: false
    };

    DamagepartState['Dunitprice'] = '$0.00';
    DamagepartState['Dunitpricenum'] = 0;
    DamagepartState['Dtestpartnum'] = '';
    DamagepartState['Dtempquantity'] = 1;
    wholeerror.DamageInvoiceNumberError = false;
    wholeerror.DamagequantityError = false;
    DamagepartState.DpartNumber = value;
    DamagepartDetails[index] = DamagepartState;
    Damageparterrors[index] = wholeerror;
    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamagepartDetails
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamagepartErrors: Damageparterrors
      }
    });
    if (value.trim() !== '') {
      WarrantyClaimService.getPartnumber('N', value, false)
        .then(response => {
          let selectedPartDetails: any[] = [];
          const partInvoiceLst: any[] = [];
          const partInvoiceShow: any[] = [];
          selectedPartDetails = response && response['data'];
          DamagepartState['DpartSelectedDetails'] = selectedPartDetails;

          selectedPartDetails.map(a => {
            return partInvoiceLst.push({
              value: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
              label: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
              invnum: a.invoiceNumber,
              isDisabled: a.availableQuantity <= 0 ? true : false,
              quantity: a.availableQuantity,
              unitPrice: a.unitPrice
            });
          });
          DamagepartState['DpartInvoiceList'] = partInvoiceLst;

          if (partInvoiceLst.length === 0) {
            DamagepartState['DpartSelectedDetails'] = [];
            DamagepartState['DinvoiceNumber'] = 0;
            DamagepartState['Dprice'] = 0;
            DamagepartState['Dpriceshow'] = '$0.00';
            DamagepartState['Dunitpricenum'] = 0;
            DamagepartState['Dquantity'] = 0;
            DamagepartState['DInvoiceOption'] = {
              value: 'Select Invoice',
              label: 'Select Invoice',
              invnum: 'Select Invoice',
              isDisabled: false
            };

            DamagepartState['Dunitprice'] = '$0.00';
            DamagepartState['Dtestpartnum'] = '';
            DamagepartState['Dtempquantity'] = 1;
          }

          DamagepartState['Dtestpartnum'] = 'filled';
          DamagepartDetails[index] = DamagepartState;
          this.setState({
            DamageData: {
              ...this.state.DamageData,

              DamagepartDetails
            }
          });
        })
        .catch(error1 => {
          this.DpartnumError(index);
        });
    }
  };

  // handle partnum error //

  private DpartnumError = (index: number) => {
    const DamagepartState = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    DamagepartState['DpartInvoiceList'] = [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false
      }
    ];
    DamagepartState['DpartSelectedDetails'] = [];
    DamagepartState['DinvoiceNumber'] = 0;
    DamagepartState['Dprice'] = 0;
    DamagepartState['Dpriceshow'] = '$0.00';
    DamagepartState['Dunitpricenum'] = 0;
    DamagepartState['Dquantity'] = 0;
    DamagepartState['DInvoiceOption'] = {
      value: 'Select Invoice',
      label: 'Select Invoice',
      invnum: 'Select Invoice',
      isDisabled: false
    };

    DamagepartState['Dorgpurchasedate'] = '';
    DamagepartState['Dunitprice'] = '$0.00';
    DamagepartState['Dtestpartnum'] = '';
    DamagepartState['Dtempquantity'] = 1;
    DamagepartState['Dmfg'] = '';
    DamagepartState['DwholePartNumber'] = '';

    DamagepartDetails[index] = DamagepartState;
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamagepartDetails
      }
    });
  };

  //   Handle invoice Number //

  private handleDamageinvoice = (inv: IDSelectOption, index: number) => {
    const customerState = { ...this.state.DamageData };
    const DamagepartState = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    DamagepartState.DinvoiceNumber = inv.invnum;
    const invnoerror = [...this.state.Damageerrors.DamagepartErrors];

    const DselectedPartDetails: IDPartSelectedDetails[] =
      DamagepartState['DpartSelectedDetails'];

    const selectedInvoice = DselectedPartDetails.filter(
      a => a.invoiceNumber === inv.invnum
    );
    // debugger;
    if (selectedInvoice && selectedInvoice.length > 0) {
      const dateInvoice = inv.value?.split("--")[1]?.trim();
      if(dateInvoice!==""){
        DamagepartState['DinvoicePurchaseDate'] = dateInvoice;
      }
      DamagepartState['invoiceNumber'] = inv.invnum;

      if (DamagepartState['DinvoiceNumber'] > 0) {
        DamagepartState['Dquantity'] = 1;
      }

      DamagepartState['Dtempquantity'] = selectedInvoice[0].availableQuantity;
      DamagepartState['Dpriceshow'] = currencyFormatter(
        selectedInvoice[0].unitPrice
      );
      DamagepartState['Dunitprice'] = currencyFormatter(
        selectedInvoice[0].unitPrice
      );
      DamagepartState['Dunitpricenum'] = selectedInvoice[0].unitPrice;
      DamagepartState['Dprice'] = selectedInvoice[0].unitPrice;
      DamagepartState['Dmfg'] = selectedInvoice[0].manufacturerCode;
      DamagepartState['DwholePartNumber'] =
        selectedInvoice[0].manufacturerCode +
        ' ' +
        DamagepartState['DpartNumber'].toUpperCase();

      DamagepartState['Dtotalprice'] = selectedInvoice[0].unitPrice.toString();

      DamagepartState['DInvoiceOption'] = {
        value: inv.invnum,
        label: inv.invnum,
        invnum: inv.invnum,
        isDisabled: inv.isDisabled,
        quantity: inv.quantity,
        unitPrice: inv.unitPrice
      };
      DamagepartState['Dtempquantity'] = inv.quantity;

      invnoerror[index].DamagequantityError = false;
      invnoerror[index].DamagequantityError = false;

      const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
      DamagepartDetails[index] = DamagepartState;
      DamagepartDetails[index].DInvoiceOption =
        DamagepartState['DInvoiceOption'];
      this.setState({
        DamageData: { ...customerState, DamagepartDetails },
        Damageerrors: {
          ...this.state.Damageerrors,
          DamagepartErrors: [...invnoerror]
        }
      });
      let error = false;
      let j;
      if (DamagepartDetails.length > 0) {
        for (j = 0; j < DamagepartDetails.length; j++) {
          if (j !== index) {
            if (
              DamagepartDetails[j].DpartNumber ===
              DamagepartState['DpartNumber']
            ) {
              if (
                DamagepartDetails[j].DinvoiceNumber ===
                DamagepartState['DinvoiceNumber']
              ) {
                error = true;

                DamagepartState['Dquantity'] = 0;
                DamagepartState['Dpriceshow'] = '$0.00';
                DamagepartState['Dprice'] = 0;
                DamagepartState['Dunitprice'] = '$0.00';
                DamagepartState['Dunitpricenum'] = 0;
                break;
              }
            }
          }
        }

        error
          ? (invnoerror[index].DamageInvoiceNumberError = error)
          : (invnoerror[index].DamageInvoiceNumberError = false);

        DamagepartDetails[index] = DamagepartState;
        this.setState({
          DamageData: { ...customerState, DamagepartDetails },
          Damageerrors: {
            ...this.state.Damageerrors,
            DamagepartErrors: [...invnoerror]
          }
        });
      } else {
        invnoerror[index].DamageInvoiceNumberError = false;
        this.setState({
          DamageData: { ...customerState, DamagepartDetails },
          Damageerrors: {
            ...this.state.Damageerrors,
            DamagepartErrors: [...invnoerror]
          }
        });
      }
    }
  };
  // Handle quantity //

  private handleDamagequantity = (event: any, index: any) => {
    const { name, value } = event.target;
    const invalidChars = ['-', '+', 'e'];

    if (!invalidChars.includes(event.key) || event.which !== 8) {
      // debugger;
      event.preventDefault();
      const DamagepartState = {
        ...this.state.DamageData.DamagepartDetails[index]
      };
      const quantityerror = [...this.state.Damageerrors.DamagepartErrors];
      const customerState = { ...this.state.DamageData };
      const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];

      const selectedPartDetails: IDPartSelectedDetails[] =
        DamagepartState['DpartSelectedDetails'];

      const selectedInvoice = selectedPartDetails.filter(
        a => a.invoiceNumber === DamagepartState['DInvoiceOption'].invnum
      );

      let pqprice;

      let error;
      DamagepartState.Dquantity = value;
      if (selectedInvoice && selectedInvoice.length > 0) {
        value > selectedInvoice[0].availableQuantity ||
        value === 0 ||
        value === '' ||
        value === '0' ||
        value < 0 ||
        value.includes('.') ||
        value === '.' ||
        value === 'e'
          ? (error = true)
          : (pqprice = selectedInvoice[0].unitPrice);

      }

      if (value > DamagepartDetails[0].DInvoiceOption['quantity']) {
        error = true;
      }
      // Resubmit validation
      if(this.props.cResubmitDetails!==undefined){
        if (value > DamagepartDetails[0].Dtempquantity) {
          error = true;
        }
        if(value === 0 ||
          value === '' ||
          value === '0' ||
          value < 0 ||
          value.includes('.') ||
          value === '.' ||
          value === 'e'){
            error = true;
          }
      }

      if (error === true && selectedInvoice.length > 0) {
        DamagepartState['Dtempquantity'] = selectedInvoice[0].availableQuantity;
        DamagepartDetails[index] = DamagepartState;
      }

      error
        ? (quantityerror[index].DamagequantityError = error)
        : (quantityerror[index].DamagequantityError = false);

      DamagepartDetails[index] = DamagepartState;

      this.setState({
        DamageData: {
          ...this.state.DamageData,

          DamagepartDetails
        }
      });
      this.setState({
        DamageData: { ...customerState, DamagepartDetails },
        Damageerrors: {
          ...this.state.Damageerrors,
          DamagepartErrors: [...quantityerror]
        }
      });
    }
  };

  //   Description of Damge   //

  private handleDamageDescription = (event: any, index: any) => {
    // debugger;
    const { name, value } = event.target;
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const damagedescriptionerror = [
      ...this.state.Damageerrors.DamagepartErrors
    ];
    const error =
      value.length > 250 ||
      !NonkeycharacterRegEx.test(value) ||
      !commentsRegEx.test(value) ||
      !/\S/.test(value);

    error
      ? (damagedescriptionerror[index].DescriptionOfDamageError = true)
      : (damagedescriptionerror[index].DescriptionOfDamageError = false);
    DamagepartDetails[index].DamageDescription = value;
    // DamagepartDetails[index].damageDescription=value;
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamagepartDetails
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamagepartErrors: [...damagedescriptionerror]
      }
    });
  };

  private handleAdditionalComment = (event: any) => {
    const { name, value } = event.target;
   
    const error = value ? 
    value ==="" ||
    value.length > 250 ||
    !NonkeycharacterRegEx.test(value) ||
    !commentsRegEx.test(value) ||
    !/\S/.test(value) : false;

    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamageAdditionalComment: value
      },
       Damageerrors: {
        ...this.state.Damageerrors,
        DamageAdditionalCommentError: error
      }
    });

  };

 
  //   Add new parts //

  private addPart = () => {
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        Ddupimage: false
      }
    });
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];

    const Damageparterrors = [...this.state.Damageerrors.DamagepartErrors];

    const Newpart = {
      ...this.DamagepartBase
    };
    Damageparterrors.push({ ...this.DamagepartError });
    DamagepartDetails.push(Newpart);

    this.setState((prevState: any) => ({
      DamageData: {
        ...prevState.DamageData,
        DamagepartDetails
      },
      Damageerrors: {
        ...prevState.Damageerrors,
        DamagepartErrors: Damageparterrors
      }
    }));
  };

  /* remove part */
  private removePart = (index: number) => {
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const Damageparterrors = [...this.state.Damageerrors.DamagepartErrors];

    DamagepartDetails.splice(index, 1);
    Damageparterrors.splice(index, 1);
    this.setState((prevState: any) => ({
      DamageData: {
        ...prevState.DamageData,
        DamagepartDetails
      },
      Damageerrors: {
        ...prevState.Damageerrors,
        DamagepartErrors: Damageparterrors
      }
    }));
  };

  // Required fiels //
  private Requiredfields = [
    'claimNumber',
    'customerNumber',
    'part.invoiceNumber',
    'part.partNumber',
    'part.quantity',
    'servicerEmail'
  ];

  //   Picture UPload  //

  private handledamagefileUpload = (upldfiles: any, index: number) => {
    const Duploadbtn = { ...this.state.DamageData.DamagepartDetails[index] };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const DpicState = [
      ...this.state.DamageData.DamagepartDetails[index].Dpicofpart
    ];
    const Dpicfile = [
      ...this.state.DamageData.DamagepartDetails[index].DfileArray
    ];
    const Dtempfile = [
      ...this.state.DamageData.DamagepartDetails[index].Dtempfilearray
    ];
    const Dimgprw = [
      ...this.state.DamageData.DamagepartDetails[index].Dimagepreview
    ];
    const Duploadpic = [
      ...this.state.DamageData.DamagepartDetails[index].Dpictureofparts
    ];

    this.setState({
      DamageData: {
        ...this.state.DamageData,
        Ddupimage: false
      }
    });
    const uploadedFiles = upldfiles.filter(
      // (file: any) => !Duploadpic.find(f => f.Dimgthumbnail === file.data)
      (file: any) => !Duploadpic.find(f => f.Dfilename === file.file.name)
    );
    if (uploadedFiles.length < upldfiles.length) {
      this.setState({
        DamageData: {
          ...this.state.DamageData,
          Ddupimage: true
        }
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (uploadedFiles.length !== 0) {
      if (DpicState[0] === '') {
        DpicState.pop();
        Dpicfile.pop();
        Dtempfile.pop();
        Dimgprw.pop();
        Duploadpic.pop();
      }
      let i;
      for (i = 0; i < uploadedFiles.length; i++) {
        this.uploadQueue.push({
          file: uploadedFiles[i].file,
          partIndex: index,
          productIndex: DpicState.length
        });
        DpicState.push(uploadedFiles[i].file.name);
        Dpicfile.push(uploadedFiles[i].file);
        Dtempfile.push(uploadedFiles[i].file);
        Duploadpic.push({
          Dfilename: uploadedFiles[i].file.name,
          Dfile: uploadedFiles[i].file,
          Dspinner: '',
          Dimagecount: DpicState.length - i,
          Dimgthumbnail: uploadedFiles[i].data
        });

        Dimgprw.push(uploadedFiles[i].data);
      }

      if (DpicState.length >= 1) {
        DamagepartDetails[index].DshowUploadModal = true;
        Duploadbtn['showUploadModal'] = true;
        DamagepartDetails[index].DshowUploadModal =
          Duploadbtn['showUploadModal'];
      } else {
        DamagepartDetails[index].DshowUploadModal = false;
        Duploadbtn['showUploadModal'] = false;
        DamagepartDetails[index].DshowUploadModal =
          Duploadbtn['showUploadModal'];
      }
      DamagepartDetails[index].Dpicofpart = DpicState;
      DamagepartDetails[index].DfileArray = Dpicfile;
      DamagepartDetails[index].Dtempfilearray = Dtempfile;
      DamagepartDetails[index].Dimagepreview = Dimgprw;
      DamagepartDetails[index].Dpictureofparts = Duploadpic;
      this.setState(
        {
          DamageData: {
            ...this.state.DamageData,
            DamagepartDetails
          }
        },
        () => {
          this.damagepicloop(uploadedFiles, index);
        }
      );
    }
  };

  private damagepicloop = async (file: any, index: any) => {
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const DuploadDetails = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    let l;
    let uploadinprogress = false;

    for (l = 0; l < DuploadDetails['Dpictureofparts'].length; l++) {
      if (DuploadDetails['Dpictureofparts'][l].Dspinner === 'start') {
        uploadinprogress = true;
      }
      if (DuploadDetails['Dpictureofparts'][l].Dspinner === '') {
        DuploadDetails['Dpictureofparts'][l].Dspinner = 'start';
      }
    }

    DamagepartDetails[index].Dpictureofparts =
      DuploadDetails['Dpictureofparts'];
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamagepartDetails
      }
    });

    if (this.uploadQueue.length === file.length) {
      this.finalupload(
        this.uploadQueue[0].file,
        this.uploadQueue[0].productIndex,
        this.uploadQueue[0].partIndex
      );
    }
  };

  private finalupload = (file: any, k: number, i: any) => {
    return new Promise((resolve, reject) => {
      const uploadDetails = { ...this.state.DamageData.DamagepartDetails[i] };
      const Duploadpic = [
        ...this.state.DamageData.DamagepartDetails[i].Dpictureofparts
      ];

      const formData = new FormData();
      formData.append(
        'accountNumber',
        this.state.DamageData.DamagecustomerNumber.toString()
      );
      formData.append(
        'claimNumber',
        this.state.DamageData.DamageclaimNumber.toString()
      );
      formData.append('file', file);
      formData.append('index', k.toString());
      formData.append(
        'invoiceNumber',
        uploadDetails['DinvoiceNumber'].toString()
      );
      formData.append('partNumber', uploadDetails['DpartNumber']);

      WarrantyClaimService.getPicofpart(formData)
        .then(response => {
          resolve(response);
          const successFile = this.uploadQueue.shift();
          if (this.uploadQueue.length) {
            this.finalupload(
              this.uploadQueue[0].file,
              this.uploadQueue[0].productIndex,
              this.uploadQueue[0].partIndex
            );
          }
          uploadDetails['Dpictureofparts'][
            successFile.productIndex
          ].Dimagecount = successFile.productIndex;
          uploadDetails['Dpictureofparts'][successFile.productIndex].Dspinner =
            'success';

          this.settingDstatecount(
            i,
            uploadDetails['Dcount'],
            'success',
            successFile.productIndex
          );
        })
        .catch(error => {
          const failureFile = this.uploadQueue.shift();
          if (this.uploadQueue.length) {
            this.finalupload(
              this.uploadQueue[0].file,
              this.uploadQueue[0].productIndex,
              this.uploadQueue[0].partIndex
            );
          }

          this.settingstateDcountfailure(
            i,
            'failure',
            failureFile.productIndex,
            error.response.data.errorMessage
          );
        });
    });
  };

  private settingstateDcountfailure = (
    partIndex: any,
    spinnerstatus: any,
    spinnerIndex: any,
    errormsg: any
  ) => {
    const uploadDetails = {
      ...this.state.DamageData.DamagepartDetails[partIndex]
    };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const errormessage =
      errormsg === 'IMG002'
        ? `${i18n.t('partClaim.invalidpic')}`
        : `${i18n.t('partClaim.delaypic')}`;
    uploadDetails['Dpictureofparts'][spinnerIndex].Dimagecount = spinnerIndex;
    uploadDetails['Dpictureofparts'][spinnerIndex].Dspinner = 'failure';
    uploadDetails['Dpictureofparts'][spinnerIndex].Dimgfail = errormessage;
    DamagepartDetails[partIndex] = uploadDetails;
    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamagepartDetails
      }
    });
  };

  private settingDstatecount = (
    partIndex: any,
    countvalue: any,
    spinnerstatus: any,
    spinnerIndex: any
  ) => {
    const uploadDetails = {
      ...this.state.DamageData.DamagepartDetails[partIndex]
    };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    uploadDetails['Dpictureofparts'][spinnerIndex].Dspinner = 'success';

    uploadDetails['Dcount'] = DamagepartDetails[partIndex].Dcount + 1;
    DamagepartDetails[partIndex].Dcount = uploadDetails['Dcount'];

    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamagepartDetails
      }
    });
  };

  //   Delete picture //

  private deleteimage = (
    index: any,
    delimgindex: any,
    i: any,
    filename: any
  ) => {
    const rs = { ...this.state.DamageData.DamagepartDetails[i] };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const delfile = filename;
    const formData = new FormData();
    formData.append(
      'claimNumber',
      this.state.DamageData.DamageclaimNumber.toString()
    );
    formData.append('fileName', delfile.toString());
    formData.append('index', delimgindex);
    formData.append('partNumber', rs['DpartNumber']);
    formData.append('invoiceNumber', rs['DinvoiceNumber'].toString());
    WarrantyClaimService.deletePicofpart(formData)
      .then(response => {
        if (response && response['data'].status === 200) {
          rs['DfileArray'].splice(index, 1);
          rs['Dtempfilearray'].splice(index, 1);
          rs['Dimagepreview'].splice(index, 1);

          rs['Dpicofpart'].splice(index, 1);
          if (rs['Dpictureofparts'][index].Dspinner === 'success') {
            rs['Dcount'] = rs['Dcount'] - 1;
          }

          rs['Dpictureofparts'].splice(index, 1);

          rs['DindexImage']--;

          if (rs['DfileArray'].length === 0) {
            rs['DindexImage'] = 0;
          }
          DamagepartDetails[i].Dcount = rs['Dcount'];
          this.setState({
            DamageData: {
              ...this.state.DamageData,

              DamagepartDetails
            }
          });
        } else {
          console.log(response, 'response');
        }
      })
      .catch(error1 => {
        console.log('picerror', error1);
      });
  };

  private removeimage = (index: any, i: any) => {
    const rs = { ...this.state.DamageData.DamagepartDetails[i] };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const delfile = rs['Dpicofpart'].splice(index, 1);
    rs['DfileArray'].splice(index, 1);
    rs['Dtempfilearray'].splice(index, 1);
    rs['Dimagepreview'].splice(index, 1);
    rs['Dpictureofparts'].splice(index, 1);
    rs['DindexImage']--;
    if (rs['DfileArray'].length === 0) {
      rs['DindexImage'] = 0;
    }

    DamagepartDetails[i].Dcount = rs['Dcount'];
    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamagepartDetails
      }
    });
  };

  // Checking for form submition //

  private Isformsubmit = () => {
    const damageData = this.Backendata();
    const result = this.Requiredfields.some(data => {
      const splitarr = data.split('.');
      let finaldata;

      switch (splitarr.length) {
        case 1:
          finaldata = damageData[splitarr[0]];
          break;

        case 2:
          if (splitarr[0] === 'part') {
            for (let i = 0; i < damageData.part.length; i++) {
              finaldata = damageData[splitarr[0]][i][splitarr[1]];
            }
          } else {
            finaldata = damageData[splitarr[0]][splitarr[1]];
          }
          break;
      }
      return finaldata === '' || finaldata === 0;
    });

    const errorsliststate = this.parterrormsg();
    const picvalidation = this.pictureValidation();
    const spinnerstate = this.failedimageremove() !== '' ? true : false;

    return (
      result ||
      !this.IsError() ||
      picvalidation ||
      errorsliststate ||
      spinnerstate
    );
  };
  // Part information error check //

  private parterrormsg = () => {
    const errorslist = [
      'DamagepartNumberError',
      'DamageInvoiceNumberError',
      'DamagequantityError'
    ];
    const damageparterrorlist = [...this.state.Damageerrors.DamagepartErrors];
    let errorsliststate = false;
    damageparterrorlist.forEach((item: any) => {
      for (const key in item) {
        if (errorslist.includes(key) && item[key] === true) {
          errorsliststate = true;
        }
      }
    });
    return errorsliststate;
  };

  // Error checking form //

  private IsError = () => {
    // console.log("=== Filters Key Array ===",this.state.Damageerrors);
    const filteredkeys = Object.keys(this.state.Damageerrors).map(
      key => this.state.Damageerrors[key]
    );
   /* if(this.state.DamageData.DamageIsPackageDeliverd===""){
      filteredkeys[4] = true;
    }
    if(this.state.DamageData.DamageIsPackageDeliverd!=="" && this.state.DamageData.DamageNoPackageReceived===0 ){
      filteredkeys[5] = true;
    } */

    if(this.state.DamageData.DamageAdditionalComment===""){
      filteredkeys[3] = true;
    }

    filteredkeys[4] = false;
    return filteredkeys.every(value => value === false);
  };

   //  Picture Validation  //

   private pictureValidation = () => {
    const pictureListFile = [...this.state.DamageData.DamagepartDetails];
    let pictureError = false;
    let picCount;
    const minimumpic = env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 4 : 3;

    for (picCount = 0; picCount < pictureListFile.length; picCount++) {
      if (pictureListFile[picCount].Dcount < minimumpic) {
        pictureError = true;
        break;
      }
    }

    return pictureError;
  };

  // picdeleteunuploaded //
  private failedimageremove = () => {
    const pictureListFile = [...this.state.DamageData.DamagepartDetails];
    let picturestate = '';
    let erroredpic;
    let erroredpicstate;
    for (erroredpic = 0; erroredpic < pictureListFile.length; erroredpic++) {
      for (
        erroredpicstate = 0;
        erroredpicstate < pictureListFile[erroredpic].Dpictureofparts.length;
        erroredpicstate++
      ) {
        if (
          pictureListFile[erroredpic].Dpictureofparts[erroredpicstate]
            .Dspinner === 'start' ||
          pictureListFile[erroredpic].Dpictureofparts[erroredpicstate]
            .Dspinner === 'failure'
        ) {
          picturestate =
            pictureListFile[erroredpic].Dpictureofparts[erroredpicstate]
              .Dspinner === 'start'
              ? 'start'
              : 'failure';
          break;
        }
      }
    }

    return picturestate;
  };

  //   Submit Damage Claim //
  private ProcessClaimData = (damagClaimData: any) => {
    this.setState({
      isSubmitButtonDisabled: true
    });
    DamageClaimService.SubmitNewTypesClaim(damagClaimData)
      .then((response: any) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.setState({
          DamageData: {
            ...this.state.DamageData,
            submittedsuccessfully: true
          }
        });
      })
      .catch((error: any) => {
        this.setState({
          isSubmitButtonDisabled: false
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.setState({
          DamageData: {
            ...this.state.DamageData,
            Damageerrormsgshow: true,
            Damageerrormsg: error.response.data.message
          }
        });
      });
  };
  private submitClaim = () => {
    const damagClaimData = this.Backendata();
    // debugger;
    if (this.Isformsubmit()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.setState({
        DamageData: {
          ...this.state.DamageData,
          Damageerrormsgshow: true
        }
      });
    } else if (damagClaimData.claimResubmit === '') {
       this.ProcessClaimData(damagClaimData);
    } else {
      DamageClaimService.checkClaimSubmitted(damagClaimData).then(
        (result: any) => {
         
          // console.log(result.data);
          if (result.data) {
            // debugger;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.setState({
              DamageData: {
                ...this.state.DamageData,
                Damageerrormsg:
                  'This claim has already been resubmitted. Please review status under "Claim Status".',
                Damageerrormsgshow: true,
                submittedsuccessfully: false
              }
            });
          } else {
            console.log("=== Claim Ready to Submit ==");
            // this.ProcessClaimData(damagClaimData);
          }
        }
      );
    }
  };
  private closemsg = () => {
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        Damageerrormsgshow: false,
        Erroredpic: this.state.DamageData.Erroredpic === true ? false : false,
        picspinnerspinning:
          this.state.DamageData.picspinnerspinning === true ? false : false,
        Ddupimage: false
      }
    });
  };

  public render() {
    return (
      <React.Fragment>
          
        {this.state.DamageData.submittedsuccessfully ? (
          <ReceivedUsedPartsubmittedPage
            claimNumber={this.state.DamageData.DamageclaimNumber}
            gotodamageClaim={this.goToDamageClaim}
            backToDashBoard={this.props.backToDashBoard}
          />
        ) : (
          <React.Fragment>
                  
          <form className="rp-Damage-claim-form" id="mydamageclaimForm">
            {this.Isformsubmit() ||
            this.state.DamageData.Damageerrormsg !== '' ? (
              <AlertMessage
                display={
                  this.state.DamageData.Damageerrormsgshow === true
                    ? true
                    : this.state.DamageData.Erroredpic ||
                      this.state.DamageData.picspinnerspinning === true
                    ? true
                    : this.state.DamageData.Ddupimage === true
                    ? true
                    : false
                }
                handleclose={this.closemsg}
                Message={
                    this.state.DamageData.Damageerrormsg !== ''
                    ? this.state.DamageData.Damageerrormsg
                    : this.parterrormsg() === true || !this.IsError()
                    ? `${i18n.t('damageClaim.pleasereviewandcorrect')}`
                    : this.state.DamageData.Ddupimage === true
                    ? `${i18n.t('damageClaim.dupimage')}`
                    : `${i18n.t('damageClaim.pleasereview')}`
                }
              />
            ) : (
              ''
            )}

            <ReceivedUsedPartClaimInfo
              DamageCustomerNumber={this.state.DamageData.DamagecustomerNumber}
              DamageClaimNumber={this.state.DamageData.DamageclaimNumber}
              DamageErrorlist={this.state.Damageerrors}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
            />

            <ReceivedUsedPartPartInfo
              DamagePartInfo={...this.state.DamageData.DamagepartDetails}
              DamagePartErrorlist={this.state.Damageerrors.DamagepartErrors}
              handleDamagePartNumber={this.handleDamagePartNumber}
              handleDamageinvoice={this.handleDamageinvoice}
              handleDamagequantity={this.handleDamagequantity}
              addPart={this.addPart}
              handleuploaddamagefiles={this.handledamagefileUpload}
              handleDeleteImage={this.deleteimage}
              handleRemoveImage={this.removeimage}
              removePart={this.removePart}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
            />

            <ReceivedUsedPartMoreInfo
              DamageAdditionalComment={this.state.DamageData.DamageAdditionalComment}
              DamageErrorlistservice={this.state.Damageerrors}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
              handleAdditionalComment={this.handleAdditionalComment}
            />

            <ReceivedUsedPartServiceInfo
              DamageservicerEmail={this.state.DamageData.DamageservicerEmail}
              DamageservicerPhone={this.state.DamageData.DamageservicerPhone}
              DamageErrorlistservice={this.state.Damageerrors}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
              handleDamageserviceremail={this.handleDamageserviceremail}
              handleDamageservicerphone={this.handleDamageservicerphone}
            />

            <div className="data-row buttons d-flex">
              <Button variant="contained" onClick={this.submitClaim} disabled={this.state.isSubmitButtonDisabled}>
                {i18n.t('partClaim.submitClaim')}
              </Button>
              {this.state.isSubmitButtonDisabled &&
              <HalfCircleSpinner
                color="#0b4da2"
                size={30}
                style={{
                  textAlign: 'center',
                  display: 'inline-block',
                  padding: '5px'
                }}
              />
              }
            </div>
          </form>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default ReceivedUsedPart;

interface IDamageClaimFormState {
  DamageData: {
    DamageaccountNumber: string;
    DamagecustomerNumber: string;
    DamageclaimNumber: string;
    Damagerefno: string;
    Damageerrormsg: string;
    Damageerrormsgshow: boolean;
    picspinnerspinning: boolean;
    Erroredpic: boolean;
    submittedsuccessfully: boolean;
    DamageservicerEmail: string;
    DamageservicerPhone: string;
    Ddupimage: boolean;
    DamagepartDetails: IDamagePartDetails[];
    DamageAdditionalComment: string;

  };
  Damageerrors?: IDamageFormErrors;
  isSubmitButtonDisabled:boolean;
}
interface IDamageFormErrors {
  DamageservicerPhoneError: boolean;
  DamageservicerEmailError: boolean;
  DamagerefnoError: boolean;
  DamageAdditionalCommentError: boolean;
  DamagepartErrors: IDamagepartErrors[];
}
interface IDamagepartErrors {
  DamagepartNumberError: boolean;
  DamageInvoiceNumberError: boolean;
  DamagequantityError: boolean;
  DamagequantityReceivedError: boolean;
  DamageUnitpriceError: boolean;
  DamageTotalpriceError: boolean;
  DescriptionOfDamageError: boolean;
}

interface IDamagePartDetails {
  DpartNumber: string;
  Dquantity: number;
  Dprice: number;
  Dunitpricenum: number;
  DinvoiceNumber: number;
  Dtempquantity: number;
  DamageDescription: string;
  Dpriceshow: string;
  Dtotalprice: string;
  Dunitprice: string;
  DshowUploadModal: boolean;
  Dpicofpart?: any[];
  DfileArray?: any[];
  Dfileobject: any[];
  Dtempfilearray?: any[];
  Duploadedfile?: any[];
  Dimagepreview?: any[];
  Dcount: number;
  Dtestpartnum: string;
  Dmfg: string;
  DwholePartNumber: string;
  Dpictureofparts?: IDPictureofparts[];
  DpartSelectedDetails?: IDPartSelectedDetails[];
  DpartInvoiceList?: IDSelectOption[];
  DInvoiceOption?: IDSelectOption;
}
interface IDPictureofparts {
  Dfilename: string;
  Dfile: any[];
  Dspinner: string;
  Dimagecount: number;
  Dimgfail?: string;
  Dimgthumbnail?: string;
}
interface IDPartSelectedDetails {
  partNumber: string;
  availableQuantity: number;
  unitPrice: number;
  invoiceNumber: string;
  purchaseDate: string;
  manufacturerCode: string;
  invoiceDate: string;
  wholePartNumber: string;
}
interface IDSelectOption {
  value: any;
  label: any;
  invnum: any;
  isDisabled: boolean;
  quantity?: any;
  unitPrice?: any;
}
